import type { PayloadAction } from "@reduxjs/toolkit";

/**
 * Shared parts of LocalServerSlice — plan §5.2. Mobile is a strict SUBSET of web: identical
 * state (all 5 fields, same defaults) and 9 identical reducers. Web adds one reducer
 * (`updateLocalServerSlice`) and the logout `extraReducers`.
 *
 * ⚠️ `action` must be `PayloadAction<any>`, never `any` — see the ledger.
 *
 * The `localServer` interface is LOCAL (not exported, and lowercase) in both apps; the
 * platform files keep it that way and extend this base.
 */
export interface SharedLocalServer {
  isLocalServerApiCall: boolean;
  isSaleSyncStarted: boolean;
  isSaleSyncing: boolean;
  unSyncedSales: any;
  networkStatus: string;
}

export const sharedInitialState: SharedLocalServer = {
  isLocalServerApiCall: false,
  isSaleSyncStarted: false,
  isSaleSyncing: false,
  unSyncedSales: [],
  networkStatus: "online",
};

/** Identical in both apps — every mobile reducer is here. */
export const sharedReducers = {
  callLocalServerMaster: (state: SharedLocalServer, action: PayloadAction<any>) => {
    state.isLocalServerApiCall = true;
  },
  callLocalServerMasterSuccess: (state: SharedLocalServer, action: PayloadAction<any>) => {
    state.isLocalServerApiCall = false;
  },
  callSyncStart: (state: SharedLocalServer, action: PayloadAction<any>) => {
    state.isSaleSyncStarted = true;
  },
  callSyncStop: (state: SharedLocalServer, action: PayloadAction<any>) => {
    state.isSaleSyncStarted = false;
  },
  syncSale: (state: SharedLocalServer, action: PayloadAction<any>) => {
    state.isSaleSyncing = true;
  },
  syncSaleSuccess: (state: SharedLocalServer, action: PayloadAction<any>) => {
    state.isSaleSyncing = false;
  },
  saveUnSyncedSale: (state: SharedLocalServer, action: PayloadAction<any>) => {
    state.unSyncedSales = action.payload;
  },
  fetchServerSaleData: (state: SharedLocalServer, action: PayloadAction<any>) => { },
  setNetworkStatus: (state: SharedLocalServer, action: PayloadAction<any>) => {
    state.networkStatus = action.payload;
  },
};
